export default "__VITE_ASSET__6b62a1ee__"